import React, { useState } from 'react';
import { modalStore } from 'components/layout/modals/ModalStore';
import { applicantStore } from '../ApplicantStore';
import { copyTextToClipboard } from 'ats/utils/copyToClipboard';
import { notificationStore } from 'components/layout/notifications/NotificationStore';
import SendCandidateInviteModal from './SendCandidateInviteModal';
import './InviteCandidateModal.sass';

export default function InviteCandidateModal({ applicant, handleSuccess }) {
	const [copySuccess, setCopySuccess] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleCopyInvitationLink = async () => {
		setLoading(true);
		try {
			const result = await applicantStore.getInviteLink(applicant.id);

			if (result.status === 'success') {
				await copyTextToClipboard(result.data.inviteLink);
				setCopySuccess(true);
				notificationStore.pushNotification({
					type: notificationStore.SUCCESS_NOTIFICATION,
					title: 'Invitation Link',
					message: 'Invitation link copied to clipboard.'
				});
				setTimeout(() => setCopySuccess(false), 2000);
				handleSuccess && handleSuccess();
			} else {
				notificationStore.pushNotification({
					type: notificationStore.ERROR_NOTIFICATION,
					title: 'Invitation Link',
					message: 'Failed to generate invitation link.'
				});
			}
		} catch (error) {
			notificationStore.pushNotification({
				type: notificationStore.ERROR_NOTIFICATION,
				title: 'Invitation Link',
				message: 'An error occurred. Please try again.'
			});
		}
		setLoading(false);
	};

	const handleSendInvitationEmail = () => {
		modalStore.openModal(
			{
				title: 'Send Invitation Email',
				size: 'md',
				position: 'center',
				saveButtonLabel: 'Send'
			},
			<SendCandidateInviteModal
				applicant={applicant}
				handleSuccess={handleSuccess}
			/>
		);
	};

	return (
		<>
			<section className="modal-card-body has-text-centered">
				<div className="InviteCandidateModal">
					<button
						className="invite-option-button"
						onClick={handleCopyInvitationLink}
						disabled={loading}>
						<div className="invite-option-icon">
							<img src="/ats/icons/link-icon.svg" alt="Copy Link" />
						</div>
						<span className="invite-option-label">
							{copySuccess ? 'Link Copied!' : 'Copy Invitation Link'}
						</span>
						<img
							src="/ats/icons/chevron-right-icon.svg"
							alt=""
							className="invite-option-arrow"
						/>
					</button>

					<button
						className="invite-option-button"
						onClick={handleSendInvitationEmail}>
						<div className="invite-option-icon">
							<img src="/ats/icons/email-blue-icon.svg" alt="Send Email" />
						</div>
						<div className="invite-option-content">
							<span className="invite-option-label">Send Invitation Email</span>
							{applicant?.email && (
								<span className="invite-option-email">{applicant.email}</span>
							)}
						</div>
						<img
							src="/ats/icons/chevron-right-icon.svg"
							alt=""
							className="invite-option-arrow"
						/>
					</button>
				</div>
			</section>
			<footer className="modal-card-foot"></footer>
		</>
	);
}
